/* global saveAs:true */
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DocumentStorageDetailController', DocumentStorageDetailController);

  DocumentStorageDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'DataUtils', 'entity', 'Notification', '$filter', '$translate', 'translationHandler'];

  function DocumentStorageDetailController($scope, $rootScope, $state, $stateParams, DataUtils, entity, Notification, $filter, $translate, translationHandler) {
    var vm = this;
    vm.documentStorage = entity;

    // Same document, different view of it - so the tab keeps the number and names the view.
    if (vm.documentStorage && vm.documentStorage.documentNumber) {
      translationHandler.setSubject(vm.documentStorage.documentNumber, 'eDocumentsApp.documentStorage.detail.title');
    }
    vm.documentId = $stateParams.id;
    vm.selectedTab = null;
    vm.loading = !entity;
    vm.download = download;
    vm.goBack = goBack;
    vm.copyToClipboard = copyToClipboard;

    var tabKeys = ['incomingString', 'typedString', 'outgoingString', 'responseString'];

    activate();

    vm.selected = function (option) {
      vm.selectedTab = option;
    };

    function clear() {
      $state.go('document');
    }

    function activate() {
      if (vm.documentStorage == null) {
        vm.loading = false;
        Notification.error({ message: $translate.instant('eDocumentsApp.documentStorage.notFound') });
        clear();
      } else {
        vm.loading = false;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.getInputType = DataUtils.getInputType;
        vm.documentStorage.incomingStringType = vm.getInputType(vm.documentStorage.incomingString);
        vm.documentStorage.typedStringType = vm.getInputType(vm.documentStorage.typedString);
        vm.documentStorage.outgoingStringType = vm.getInputType(vm.documentStorage.outgoingString);
        vm.documentStorage.responseStringType = vm.getInputType(vm.documentStorage.responseString);

        if (vm.documentStorage.incomingStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.incomingString = angular.fromJson(vm.documentStorage.incomingString);
        }
        if (vm.documentStorage.typedStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.typedString = angular.fromJson(vm.documentStorage.typedString);
        }
        if (vm.documentStorage.outgoingStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.outgoingString = angular.fromJson(vm.documentStorage.outgoingString);
        }
        if (vm.documentStorage.responseStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.responseString = angular.fromJson(vm.documentStorage.responseString);
        }

        // Set default selected tab to the first available one
        for (var i = 0; i < tabKeys.length; i++) {
          if (vm.documentStorage[tabKeys[i]]) {
            vm.selectedTab = tabKeys[i];
            break;
          }
        }

        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:documentStorageUpdate', function (event, result) {
          vm.documentStorage = result;
        });
        $scope.$on('$destroy', unsubscribe);
      }
    }

    function getSelectedData() {
      if (!vm.selectedTab || !vm.documentStorage) {
        return undefined;
      }
      return vm.documentStorage[vm.selectedTab];
    }

    function getSelectedType() {
      if (!vm.selectedTab || !vm.documentStorage) {
        return undefined;
      }
      return vm.documentStorage[vm.selectedTab + 'Type'];
    }

    function dataToString(data, type) {
      if (!data) return '';
      if (type === 'JSON' || angular.isObject(data)) {
        return JSON.stringify(data, null, '\t');
      }
      return data;
    }

    function copyToClipboard() {
      var data = getSelectedData();
      if (!angular.isDefined(data)) return;

      var type = getSelectedType();
      var text = dataToString(data, type);

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(function () {
            Notification.success({
              message: $translate.instant('eDocumentsApp.documentStorage.copied'),
              delay: 3000,
            });
          })
          .catch(function () {
            Notification.error({
              message: $translate.instant('eDocumentsApp.documentStorage.copyError'),
            });
          });
      }
    }

    function download() {
      var data = getSelectedData();
      if (angular.isDefined(data)) {
        var blob;
        var type = vm.getInputType(data).toLowerCase();
        switch (type) {
          case 'json':
            blob = new Blob([JSON.stringify(data, null, '\t')], {
              type: 'application/' + type,
            });
            break;
          case 'xml':
            blob = new Blob([data], {
              type: 'application/' + type,
            });
            break;
          default:
            blob = new Blob([data], {
              type: 'application/text',
            });
            type = 'txt';
        }
        var dateTime = $filter('date')(new Date(), 'HHmmddMMyyyy');

        var filename = 'Document_' + vm.documentStorage.documentId + dateTime + '.' + type;
        saveAs(blob, filename, true);
      }
    }

    function goBack() {
      window.history.back();
    }
  }
})();
